{
  "mar": {
    "title": "給藥紀錄",
    "loading": "載入給藥紀錄中...",
    "emptyState": "此病人尚無使用中的用藥醫囑",
    "loadError": "載入藥物失敗",
    "retry": "重試",
    "previousDay": "前一日",
    "nextDay": "後一日",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "班別",
    "dayShiftHeader": "白班（07:00 - 19:00）",
    "nightShiftHeader": "夜班（19:00 - 07:00）",
    "newOrder": "新增用藥醫囑",
    "printMar": "列印給藥紀錄",
    "prnSection": "必要時（PRN）用藥",
    "filter": {
      "timeWindow": "時間範圍",
      "category": "類別",
      "status": "狀態",
      "scheduledOnly": "僅顯示排定給藥"
    },
    "adminStatus": {
      "scheduled": "已排定",
      "dueNow": "時間到",
      "overdue": "逾期",
      "administered": "已給藥",
      "held": "暫停",
      "refused": "拒絕",
      "missed": "遺漏"
    },
    "columns": {
      "medication": "藥品",
      "drug": "藥品",
      "doseRoute": "劑量 / 途徑",
      "schedule": "排程",
      "scheduledTime": "排定時間",
      "givenTime": "給藥時間",
      "givenBy": "給藥人員",
      "status": "狀態"
    },
    "actions": {
      "administer": "給藥",
      "hold": "暫停",
      "refuse": "拒絕",
      "skip": "略過",
      "missed": "標記為遺漏",
      "edit": "編輯給藥",
      "viewHistory": "檢視歷程",
      "givePrn": "PRN 給藥"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "高警示藥品",
      "indication": "適應症：{{indication}}",
      "lastGiven": "上次給藥：{{time}}",
      "lastGivenBy": "上次給藥：{{time}}（{{user}}）"
    },
    "orderBadge": {
      "active": "使用中",
      "onHold": "暫停中",
      "discontinued": "已停用"
    },
    "legend": "圖例：",
    "summary": {
      "medsGivenToday": "今日已給藥：",
      "ofTotal": "{{given}} / {{total}}",
      "overdueCount_one": "逾期 {{count}} 項",
      "overdueCount_other": "逾期 {{count}} 項",
      "nextDue": "下次給藥：",
      "nextDueAt": "{{medName}}，{{time}}"
    },
    "tooltip": {
      "given": "（已給藥 {{time}}）",
      "pending": "正在記錄… 伺服器尚未確認"
    },
    "doseModal": {
      "title": "給藥",
      "doseGiven": "實際給藥劑量",
      "siteOfAdministration": "給藥部位",
      "comments": "備註",
      "vitalsCheck": "給藥前生命徵象核對",
      "doubleCheck": "雙人核對",
      "verifier": "核對人員",
      "confirm": "確認給藥"
    },
    "administerDialog": {
      "doseLabel": "劑量",
      "routeLabel": "給藥途徑",
      "siteLabel": "給藥部位（如適用）",
      "site": {
        "notApplicable": "不適用",
        "leftArm": "左臂",
        "rightArm": "右臂",
        "leftDeltoid": "左三角肌",
        "rightDeltoid": "右三角肌",
        "leftGluteal": "左臀",
        "rightGluteal": "右臀",
        "leftThigh": "左大腿",
        "rightThigh": "右大腿",
        "abdomen": "腹部"
      },
      "timeAdministered": "給藥時間",
      "administeredDateAria": "給藥日期",
      "administeredTimeAria": "給藥時刻",
      "notesLabel": "備註",
      "notesPlaceholder": "選填備註..."
    },
    "prnWarning": {
      "title": "PRN 間隔時間警示",
      "lastDoseHoursAgo": "上次給藥距今 {{hours}} 小時。",
      "minimumInterval": "最短間隔為 {{hours}} 小時。",
      "lastAdministered": "上次給藥：{{time}}",
      "justificationLabel": "提前給藥之臨床理由",
      "justificationRequired": "*",
      "justificationPlaceholder": "請填寫早於最短間隔給藥的臨床理由...",
      "cancel": "取消",
      "overrideContinue": "覆寫並繼續"
    },
    "toast": {
      "administered": "已記錄給藥",
      "administerError": "記錄給藥失敗",
      "administerNotImplemented": "MAR 給藥記錄尚未啟用",
      "held": "已暫停給藥",
      "refused": "已記錄病人拒絕",
      "skipped": "已略過此次給藥",
      "orderNotActive": "此醫囑已不再有效（已停用、取消或完成），無法執行給藥。"
    },
    "holdRefuseDialog": {
      "holdTitle": "暫停給藥",
      "refuseTitle": "拒絕給藥",
      "skipTitle": "略過給藥",
      "scheduledLabel": "排定：{{time}}",
      "holdReasonLabel": "暫停原因",
      "refusalNotesLabel": "拒絕紀錄",
      "skipReasonLabel": "略過原因",
      "holdReasonPlaceholder": "請填寫暫停原因...",
      "refusalPlaceholder": "記錄病人拒絕情況...",
      "skipPlaceholder": "請填寫略過原因...",
      "cancel": "取消",
      "confirm": "確認"
    },
    "contextMenu": {
      "hold": "暫停",
      "refuse": "拒絕",
      "skip": "略過"
    },
    "holdReason": {
      "label": "暫停原因",
      "options": {
        "patientNpo": "病人 NPO（禁食）",
        "vitalsOutOfRange": "生命徵象超出範圍",
        "patientRefused": "病人拒絕",
        "providerOrder": "醫師指示暫停",
        "other": "其他"
      }
    },
    "give": {
      "title": "給藥 · {{medication}} {{dose}}",
      "scheduledLabel": "排定 {{time}}",
      "patientLabel": "病人",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "病人ID：{{id}}",
      "medicationLabel": "藥品",
      "scanPatientPlaceholder": "掃描手圈",
      "scanPatientAria": "掃描病人手圈",
      "scanMedicationPlaceholder": "掃描藥品包裝條碼",
      "scanMedicationAria": "掃描藥品包裝",
      "patientMismatch": "此手圈不屬於該病人。請勿給藥。",
      "medicationMismatch": "此包裝不是醫囑藥品。請勿給藥。",
      "notScannable": "無法掃描核對 — 此醫囑未登錄條碼",
      "overrideReason": "未掃描即給藥的理由",
      "overrideReasonPlaceholder": "例如：手圈破損；無條碼的調配劑量",
      "pharmacyOverride": "藥劑科尚未審核此高警示藥品",
      "pharmacyOverridePlaceholder": "此次給藥為何不能等待藥劑科審核？",
      "timeLabel": "時間",
      "detailsEdit": "編輯",
      "detailsDone": "完成",
      "confirmLabel": "以上資訊與醫囑及手中藥品一致",
      "cancel": "取消",
      "submit": "給藥",
      "witness": {
        "banner": "高警示藥品 — 需第二位護理師覆核",
        "usernameLabel": "第二位護理師帳號",
        "passwordLabel": "密碼",
        "verify": "覆核",
        "verifying": "覆核中…",
        "verified": "已由第二位護理師覆核",
        "rejected": "無法辨識該帳號或密碼。",
        "overrideLabel": "無法覆核？未經第二位護理師覆核即給藥 — 理由",
        "overridePlaceholder": "此次給藥為何不能等待獨立雙人覆核？"
      },
      "refusal": {
        "wrongPatient": "病人不符 — 掃描的手圈與此醫囑不相符。請勿給藥。",
        "wrongMedication": "藥品不符 — 掃描的包裝與醫囑藥品不相符。請勿給藥。",
        "scanRequired": "請掃描手圈與藥品，或填寫未掃描的理由。",
        "pharmacyVerificationRequired": "藥劑科尚未審核此醫囑。請等待審核，或記錄無法等待的理由。",
        "doubleCheckRequired": "尚無第二位護理師對此醫囑進行雙人覆核。請安排覆核，或記錄無法等待的理由。",
        "doubleCheckSelf": "不能由本人覆核自己的給藥。須由第二位護理師覆核。"
      },
      "dispense": {
        "handedOver": "{{quantity}} 已於 {{time}} 交付",
        "label": "藥房發藥",
        "none": "此醫囑暫無發藥記錄",
        "pending": "已記錄發藥，尚未交付",
        "prepared": "{{quantity}} 已於 {{time}} 配置",
        "unavailable": "無法查詢發藥情況——未能讀取記錄"
      }
    }
  },
  "status": {
    "active": "使用中",
    "held": "暫停",
    "discontinued": "停用",
    "completed": "已完成",
    "refused": "拒絕",
    "missed": "遺漏",
    "given": "已給藥"
  },
  "route": {
    "po": "口服",
    "iv": "靜脈注射",
    "im": "肌肉注射",
    "sc": "皮下注射",
    "in": "鼻腔",
    "pr": "肛門",
    "sl": "舌下",
    "top": "外用",
    "neb": "霧化吸入",
    "pv": "陰道",
    "ng": "鼻胃管",
    "ophthalmic": "眼用",
    "transdermal": "經皮"
  },
  "frequency": {
    "bid": "每日兩次",
    "tid": "每日三次",
    "qid": "每日四次",
    "qd": "每日一次",
    "qhs": "睡前",
    "prn": "必要時（PRN）",
    "stat": "立即（STAT）",
    "continuous": "連續給藥"
  },
  "formulary": {
    "title": "藥品處方集",
    "searchPlaceholder": "依藥品名、學名或代碼搜尋...",
    "clearSearch": "清除搜尋",
    "category": {
      "all": "全部",
      "analgesic": "止痛類",
      "antibiotic": "抗生素",
      "antifungal": "抗黴菌藥",
      "antiviral": "抗病毒藥",
      "cardiac": "心血管類",
      "endocrine": "內分泌類",
      "gi": "腸胃道類",
      "neurological": "神經系統類",
      "psychiatric": "精神科類",
      "respiratory": "呼吸系統類",
      "other": "其他"
    },
    "columns": {
      "medication": "藥品",
      "genericName": "學名",
      "form": "劑型",
      "strength": "規格",
      "route": "給藥途徑",
      "status": "狀態",
      "schedule": "管制等級"
    },
    "highAlertBadge": "高警訊藥品",
    "highAlertTag": "高警訊",
    "status": {
      "preferred": "首選",
      "restricted": "限制使用",
      "nonFormulary": "非處方集"
    },
    "loading": "正在載入處方集...",
    "loadError": "無法載入處方集",
    "empty": "未找到藥品。",
    "pagination": {
      "showing": "顯示 {{from}}-{{to}}（共 {{total}} 筆）",
      "page": "第 {{page}} 頁，共 {{totalPages}} 頁",
      "previous": "上一頁",
      "next": "下一頁"
    },
    "details": {
      "close": "關閉詳情",
      "genericName": "學名",
      "category": "類別",
      "formStrength": "劑型 / 規格",
      "route": "給藥途徑",
      "formularyStatus": "處方集狀態",
      "deaSchedule": "DEA 管制等級",
      "indications": "適應症",
      "contraindications": "禁忌症",
      "interactions": "藥物交互作用",
      "sideEffects": "副作用",
      "dosageGuidelines": "用法用量",
      "specialPopulations": "特殊族群",
      "storage": "貯存"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "藥師審核佇列",
    "subtitle": "審核並核對待處理的醫囑",
    "pendingCount": "待審核 {{count}} 項",
    "refresh": "重新整理",
    "searchPlaceholder": "依藥品、病人姓名或 MRN 搜尋...",
    "priority": {
      "all": "全部優先級",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "常規",
      "scheduled": "預定"
    },
    "loadError": "無法載入醫囑佇列",
    "retry": "重試",
    "empty": {
      "title": "全部處理完畢",
      "description": "沒有待審核的醫囑。"
    },
    "columns": {
      "patient": "病人",
      "medication": "藥品",
      "doseRouteFreq": "劑量 / 途徑 / 頻次",
      "priority": "優先級",
      "orderingProvider": "開立醫師",
      "ordered": "開立時間",
      "actions": "操作"
    },
    "row": {
      "unknown": "未知",
      "mrnLabel": "MRN：{{mrn}}",
      "mrnUnknown": "---",
      "controlled": "管制藥 {{schedule}}",
      "providerFallback": "醫師 #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "核對",
      "verifyTooltip": "核對此醫囑",
      "reject": "退回",
      "rejectTooltip": "退回並停用",
      "confirmReject": "確認",
      "cancelReject": "取消",
      "rejectReasonPlaceholder": "退回原因..."
    },
    "toast": {
      "verifySuccess": "醫囑 #{{id}} 已核對",
      "verifyError": "核對醫囑失敗",
      "rejectSuccess": "醫囑 #{{id}} 已退回並停用",
      "rejectError": "退回醫囑失敗",
      "rejectReasonRequired": "請填寫退回原因",
      "notIndependent": "開立醫囑者不能核對自己的醫囑。",
      "overrideSuccess": "醫囑 {{id}} 已在未經藥師核對的情況下生效",
      "overrideError": "無法記錄越權",
      "overrideReasonRequired": "越權需同時填寫原因代碼與理由"
    },
    "verifyDialog": {
      "title": "核對用藥醫囑",
      "instruction": "請確認已完成的每一項檢查。四項均為必填——部分複核不構成核對。",
      "checks": {
        "allergy": "我已對照病人過敏史複核此醫囑",
        "interaction": "我已複核藥物交互作用",
        "duplicateTherapy": "我已複核重複用藥",
        "doseRange": "我已複核該病人的劑量"
      },
      "cancel": "取消",
      "confirm": "核對醫囑"
    },
    "override": {
      "action": "越權放行",
      "confirm": "記錄越權",
      "cancel": "取消",
      "tooltip": "在未經藥師核對的情況下繼續。會記錄原因；不滿足高警訊藥品的藥局核查。",
      "codeLabel": "越權原因代碼",
      "codePlaceholder": "請選擇原因…",
      "justificationLabel": "越權理由",
      "justificationPlaceholder": "為何在未經藥局複核的情況下繼續？",
      "code": {
        "pharmacyClosed": "藥局已關閉",
        "urgentClinicalNeed": "緊急臨床需要",
        "pharmacyUnreachable": "無法聯繫藥局"
      }
    },
    "clarify": {
      "action": "釐清",
      "tooltip": "藥局對該醫囑的編碼與原處方不同。須先處理才能給藥。",
      "heading": "藥局編碼與原處方不同",
      "holding": "（暫停該醫囑）",
      "upheld": "維持原醫囑",
      "upheldTooltip": "原醫囑正確，依原樣調配。",
      "amended": "我已修改",
      "amendedTooltip": "記錄該醫囑已被修改。",
      "adopt": "採納藥局版本",
      "adoptTooltip": "依協作執業協議或藥事委員會方案接受編碼版本。",
      "close": "關閉",
      "toast": {
        "resolved": "釐清已處理；醫囑返回待核對",
        "error": "無法處理該釐清"
      }
    }
  },
  "reconciliation": {
    "title": "用藥整合",
    "subtitle": "{{patient}} | {{mrn}} | 就診 #{{encounter}}",
    "complete": "完成整合",
    "loading": "正在載入用藥...",
    "column": {
      "home": "院前用藥",
      "inpatient": "住院用藥",
      "discharge": "出院用藥"
    },
    "emptyHome": "未找到院前用藥。",
    "emptyInpatient": "未找到住院用藥。",
    "emptyDischarge": "尚無出院用藥。請在其他欄繼續或修改用藥。",
    "changedFromHome": "與院前用藥相比已變更",
    "action": {
      "continue": "繼續",
      "modify": "修改",
      "discontinue": "停用",
      "discontinueShort": "D/C",
      "newOrder": "新增"
    },
    "addToDischarge": "加入出院用藥",
    "remove": "移除",
    "modifyForm": {
      "title": "修改用藥",
      "dose": "劑量",
      "route": "給藥途徑",
      "frequency": "頻次",
      "dosePlaceholder": "例如：500mg",
      "routePlaceholder": "例如：PO",
      "frequencyPlaceholder": "例如：BID",
      "cancel": "取消",
      "save": "儲存"
    },
    "back": "返回",
    "toast": {
      "completed": "用藥整合已完成",
      "completeError": "完成整合失敗",
      "atLeastOne": "請至少整合一項用藥後再完成"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "劑量計算器",
      "weightLabel": "病人體重 (kg) *",
      "heightLabel": "身高 (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "例如 70",
      "heightPlaceholder": "例如 170",
      "gfrPlaceholder": "選填",
      "bsaLabel": "計算的體表面積 (Mosteller):",
      "calculate": "計算劑量",
      "error": "無法計算劑量。後端可能沒有此藥物的劑量資料。",
      "renalAdjustment": "腎功能調整:",
      "originalDose": "原始劑量:",
      "min": "最小:",
      "max": "最大:",
      "recommended": "建議: {{dose}} {{unit}}",
      "apply": "套用劑量",
      "method": {
        "weightBased": "依體重",
        "bsaBased": "依體表面積",
        "flat": "固定劑量",
        "renalAdjusted": "腎功能調整"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "開立藥物處方",
    "submit": "開立處方",
    "navButton": "開處方",
    "noActiveEncounter": "處方必須連結至有效就診。請先為此病人建立或收治就診，再開立處方。",
    "fields": {
      "medication": "藥物",
      "dose": "劑量",
      "doseUnit": "單位",
      "route": "給藥途徑",
      "frequency": "頻次",
      "frequencyDescription": "頻次說明",
      "duration": "療程",
      "durationUnit": "療程單位",
      "totalDoses": "總劑次",
      "isPrn": "需要時（PRN）",
      "prnIndication": "需要時適應症",
      "administrationInstructions": "給藥說明",
      "patientInstructions": "病人須知",
      "quantityDispensed": "調劑數量",
      "refillsAuthorized": "可續領次數",
      "allowSubstitution": "允許學名藥替代",
      "pharmacyNotes": "藥局備註",
      "indication": "適應症",
      "clinicalIndication": "臨床適應症",
      "priority": "優先順序"
    },
    "sections": {
      "drug": "藥物",
      "dosing": "劑量",
      "durationPrn": "療程與需要時（PRN）",
      "instructions": "用藥說明",
      "dispensing": "調劑",
      "clinical": "臨床"
    },
    "doseUnitPlaceholder": "如 mg",
    "drugSearch": {
      "placeholder": "搜尋藥品處方集…",
      "noResults": "沒有相符的處方集藥品",
      "clear": "清除選擇",
      "catalogRequired": "請從處方集中選擇要開立的藥品",
      "catalogOnly": "僅可開立處方集內藥品，以確保各項安全檢查均可執行。",
      "controlledBadge": "管制藥品 — 第 {{schedule}} 級",
      "controlledTag": "管制",
      "highAlertBadge": "高警訊藥品",
      "highAlertTag": "高警訊",
      "contraindications": "禁忌症：{{text}}"
    },
    "route": {
      "oral": "口服（PO）",
      "iv": "靜脈注射（IV）",
      "subcutaneous": "皮下注射（SC）",
      "intramuscular": "肌肉注射（IM）",
      "topical": "外用",
      "inhalation": "吸入",
      "rectal": "直腸給藥（PR）",
      "ophthalmic": "眼用",
      "transdermal": "經皮"
    },
    "frequency": {
      "QD": "每日一次（QD）",
      "BID": "每日兩次（BID）",
      "TID": "每日三次（TID）",
      "QID": "每日四次（QID）",
      "Q4H": "每4小時一次（Q4H）",
      "Q6H": "每6小時一次（Q6H）",
      "Q8H": "每8小時一次（Q8H）",
      "Q12H": "每12小時一次（Q12H）",
      "QHS": "睡前（QHS）",
      "PRN": "需要時（PRN）",
      "STAT": "立即（STAT）"
    },
    "durationUnit": {
      "days": "天",
      "weeks": "週",
      "months": "月",
      "doses": "劑次"
    },
    "priority": {
      "routine": "常規",
      "asap": "盡快",
      "stat": "立即"
    },
    "validation": {
      "prnIndicationRequired": "需要時醫囑必須填寫需要時適應症"
    },
    "contextBar": {
      "ariaLabel": "開方參考資訊",
      "allergies": {
        "label": "過敏史",
        "none": "無已知過敏",
        "severe": "嚴重"
      },
      "weight": {
        "label": "體重",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "未記錄"
      },
      "renal": {
        "label": "腎功能",
        "value": "eGFR {{egfr}} {{unit}}（{{source}}）",
        "unknown": "腎功能未知",
        "source": {
          "reported": "報告值",
          "computed": "計算值",
          "unknown": "未知"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "藥物已開立",
      "error": "無法開立此醫囑，請重試。",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "已開立，附帶安全提示",
      "continue": "繼續"
    },
    "safetyReview": {
      "title": "需要安全審查",
      "proceed": "覆寫並開立",
      "cancel": "取消",
      "reasonPrompt": "選擇覆寫理由…",
      "freeTextLabel": "補充說明",
      "freeTextPlaceholder": "加入臨床背景（可選）",
      "hardBlockNote": "此攔截無法覆寫。",
      "cannotOverride": "此處方無法繼續——一個或多個攔截無法覆寫。",
      "blockKind": {
        "cds_contraindication": "禁忌",
        "cds_unavailable": "安全篩檢不可用",
        "renal_contraindication": "腎功能禁忌",
        "dose_range": "劑量超出建議範圍",
        "pregnancy_contraindication": "妊娠風險",
        "unknown": "其他安全攔截"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "已手動審查病史",
        "NO_KNOWN_RISK_THIS_PATIENT": "該病患無已知風險",
        "URGENT_CLINICAL_NEED": "緊急臨床需要",
        "OTHER": "其他（請說明）",
        "BENEFIT_OUTWEIGHS_RISK": "獲益大於風險",
        "DOSE_REDUCED_PER_PROTOCOL": "已依方案減量",
        "EGFR_NOT_REPRESENTATIVE": "eGFR不具代表性",
        "SPECIALIST_ADVICE": "專科意見",
        "PATIENT_TOLERANT": "病患可耐受此劑量",
        "SPECIALIST_PROTOCOL": "遵循專科方案",
        "TITRATING_TO_EFFECT": "依療效滴定",
        "RANGE_NOT_APPLICABLE": "範圍不適用",
        "STATUS_CONFIRMED_NEGATIVE": "已確認未懷孕",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "益處大於胎兒風險",
        "CONTRACEPTION_CONFIRMED": "已確認有效避孕",
        "PREGNANCY_BEING_TERMINATED": "正在終止妊娠"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
